export const stakingAddress = "0x98C8f021418D09D48d5021701B8e6886531967B9";
export const defaulatAddress = "0x76E51A5B48A8C4c0DFE1B0A6d9A8EF76D79Eb105";
